import { render, staticRenderFns } from "./DeleteAppointment.vue?vue&type=template&id=3743d3da"
import script from "./DeleteAppointment.vue?vue&type=script&lang=js"
export * from "./DeleteAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports